export { default } from './SvgColor'
export type * from './types'
export * from './classes'
